import React from "react";
import Login from "./Authentication/Login";

import { Swiper,Autoplay} from "swiper/react/swiper";
import { SwiperSlide } from "swiper/react/swiper-slide";

import "swiper/swiper.min.css";

import moment from "moment";

const Homepage = () => {
  function openNav() {
    // document.getElementById("mySidenav").style.width = "260px";
    document.getElementById("mySidenav").style.width = "400px";
  }

  function closeNav() {
    document.getElementById("mySidenav").style.width = "0";
  }

  return (
    <div>
      <div class="banner"></div>
      <nav
        class="navbar navbar-expand-lg navbar-light fixed-top"
        aria-label="Fourth navbar example "
        id="header_top"
      >
        <div class="container-fluid" id="nav_bdr">
          <a class="navbar-brand" href="/">
            <img
              src="img/footer.logo.png"
              alt="logo"
              style={{ height: " 50px", width: "100%" }}
            />
          </a>
          {/* <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarsExample04"
                        aria-controls="navbarsExample04" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button> */}
          <span
            class="navbar-toggler-icon"
            onClick={() => openNav()}
            id="bars"
          ></span>
          <div class="collapse navbar-collapse back_prev" id="navbarsExample04">
            <ul class="navbar-nav ms-auto" style={{ margin: "auto" }}>
              <li class="nav-item">
                <a class="nav-link" aria-current="page" href="#" id="act">
                  Home
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#about">
                  About Us
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#service">
                  Service
                </a>
              </li>
            </ul>
            <div class="head_btn">
              <a href="#footer">
                <button class="st_style commonfontfamily">Contact Us</button>
              </a>
            </div>
          </div>
        </div>
      </nav>

      <div class="banner-text">
        <h1>
          Give a touch of <br />
          <span>ELEGANCE </span> to your
          <br />
          Home Interiors
        </h1>
      </div>

      <div className="homelogin">
        <Login />
      </div>

      <div class="mobile">
        <div id="mySidenav" class="sidenav">
          <a href="#" class="closebtn" onClick={() => closeNav()}>
            &times;
          </a>
          <img
            className="sidebarlogooffcanva"
            src="../img/footer.logo.png"
            alt="logo"
          />
          <li class="second_nav firstlisttopmargin">
            <a class="nav-link" href="/" onClick={() => closeNav()}>
              Home
            </a>
          </li>
          <li class="second_nav">
            <a class="nav-link" href="#about" onClick={() => closeNav()}>
              About Us
            </a>
          </li>
          <li class="second_nav">
            <a class="nav-link" href="#service" onClick={() => closeNav()}>
              Service
            </a>
          </li>
          <li class="second_nav">
            <a class="nav-link" href="#footer" onClick={() => closeNav()}>
              Contact
            </a>
          </li>
        </div>
      </div>

      {/* <!-- Category section --> */}

      <div class="category">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 text-center">
              <div class="main">
                <h1>
                  <span> Category Range</span>
                </h1>
              </div>
            </div>

            <Swiper
            // loop={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
            
              className="swiperwidth"
              spaceBetween={10}
              slidesPerView={5}
              breakpoints={{
                5000: {
                  width: 576,
                  slidesPerView: 5,
                },
                1924: {
                  width: 576,
                  slidesPerView: 5,
                },
                768: {
                  width: 768,
                  slidesPerView: 3,
                },
                350: {
                  width: 768,
                  slidesPerView: 3,
                },
                100: {
                  width: 768,
                  slidesPerView: 3,
                },
              }}
              
              onSlideChange={() => console.log("slide change")}
              onSwiper={(swiper) => console.log(swiper)}
            >
              <SwiperSlide>
                <div class="card-category overflow-hidden ">
                  <img
                    className="img-hover"
                    src="img/Modular Wardrobe.png"
                    alt="Card image cap"
                  />
                  <div class="card_txt card-body">
                    <p class="card-text">Modular Wardrobe</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div class="card-category overflow-hidden">
                  <img
                    className="img-hover"
                    src="img/Hardware.png"
                    alt="Card image cap"
                  />
                  <div class="card_txt card-body">
                    <p class="card-text">Hardware</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div class=" card-category overflow-hidden">
                  <img
                    className="img-hover"
                    src="img/Sanitaryware.png"
                    alt="Card image cap"
                  />
                  <div class="card_txt card-body">
                    <p class="card-text">Sanitaryware</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div class="card-category overflow-hidden ">
                  <img
                    className="img-hover"
                    src="img/Modular Kitchen.png"
                    alt="Card image cap"
                  />
                  <div class="card_txt card-body">
                    <p class="card-text">Modular Kitchen</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div class=" card-category overflow-hidden">
                  <img
                    className="img-hover"
                    src="img/BathAccessories.png"
                    alt="Card image cap"
                  />
                  <div class="card_txt card-body">
                    <p class="card-text">Bath Accessories</p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>

      {/* <!-- About --> */}

      <section class="about" id="about">
        <div class="container-fluid" style={{ padding: "0px 20px" }}>
          <div class="row">
            <div class="col-12 text-center">
              <div class="main">
                <h1>
                  <span>About Us</span>
                </h1>
              </div>
            </div>

            {/* <div class="row flex-column-reverse flex-lg-row m-0 p-0"> */}
            <div class="row m-0 p-0">
              <div class="col-md-12 col-lg-12 col-xl-7">
                <div class="about_p">
                  <p>
                    Established in the year 1966 “Kalanjiam” has earned a
                    reputation of being the best in the Hardware, Sanitary wares
                    and Modular kitchen Accessories business. Our renowned
                    management group comprises of professionals involved in
                    different aspects of the hardware industry. Our sales team
                    possesses the knowledge and necessary experience to bring to
                    our esteemed customers the best-in-class products from the
                    most reputed brands. We closely understand our client’s
                    requirements and strive to procure products from any corner
                    of the world.
                    <br />
                    <br />
                    We have established ourselves as one of India’s premier and
                    exclusive stores. We have products from a wide range of
                    International Brands like Stanley of the USA, and Italian
                    Brands like Linea Cali, Salice Paolo, Omporo, Yale, Vellanti
                    and Bossetti. Austrian brands like Swarovski. German Brands
                    like Hafele, Blum, Alno, Grass, Huwil and Mapla.
                    <br />
                    <br />
                    The Home Brands are Godrej, PAG, Jaguar, Parryware,
                    Hallmark, Elvis, Glen, Dyna, Supra, Lifeline, Mayur, Door
                    Plus, Renold, Euro, Adhunik, Garg, I80, Focus, Ozone, Enox,
                    Sterling, Collins, Archies, Archis, Ipsa, Imex, Supra, Ekri,
                    Meedos, Europa, Link, Milton, Rolex, Decor, Rajbadri, Elica,
                    Sleek, Dorma, Dichkaro, Bolton, Golden, Watertec, Gesign,
                    Yahya, Toyo, Kimberli Clark, Chitra, Germa and Asian.
                  </p>
                </div>
              </div>
              <div class="col-md-12 col-lg-12 col-xl-5">
                <img
                  src="img/About.png"
                  alt="about"
                  class="img-fluid"
                  style={{ height: "96%", width: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- banner1 --> */}
      <div class="mains" id="service">
        <div class="banner2">
          <div class="cards">
            <div class="container-fluid" style={{ padding: "0px 20px" }}>
              <div class="row ">
                <div class="col-xl-2 col-lg-6 col-md-12  text-center bdr">
                  <div class="icons1">
                    <img src="img/icon3.png" alt="icon3" class="img-fluid" />
                  </div>
                  <div class="icon_txt1">
                    <p style={{ fontSize: "16px" }}>
                      Free Modular <br />
                      Kitchen Consulation
                    </p>
                  </div>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-12 text-center bdr">
                  <div class="icons">
                    <img src="img/icon2.png" alt="icon2" class="img-fluid" />
                  </div>
                  <div class="icon_txt">
                    <p style={{ fontSize: "16px" }}>Free shipping</p>
                  </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-12  text-center bdr">
                  <div class="icons">
                    <img src="img/icon1.png" alt="icon1" class="img-fluid" />
                  </div>
                  <div class="icon_txt">
                    <p style={{ fontSize: "16px" }}>
                      Locking Fixing <br />
                      By Experts
                    </p>
                  </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-12 man">
                  <div class="icon_head">
                    <h3>Value Added Services</h3>
                  </div>
                  <div class="icon_txtp">
                    <p style={{ fontSize: "16px" }}>
                      Get experts consultation, free shipping, doorstep fixing &
                      installation by our professional crew
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- footer --> */}
      <footer id="footer">
        <div class="container-fluid" style={{ padding: "0px 20px" }}>
          <div class="row">
            <div class="col-md-12 col-lg-4">
              <div class="footer_logo">
                <a href="/">
                  <img
                    src="img/footer.logo.png"
                    alt="footer.logo"
                    class="img-fluid"
                    style={{ height: "50px" }}
                  />
                </a>
              </div>
              <div class="company_about">
                <p style={{ fontSize: "16px" }}>
                  We believe that Servitude is the best attitude. Whether it’s
                  the basics or premium services, exceeding customer
                  expectations have always been our top most priority.
                </p>
              </div>
              <div class="soc_icon d-flex">
                <li>
                  <a
                    href="https://www.facebook.com/KalanjiamHardwaresOnlineRetailStore/"
                    target="_blank"
                  >
                    <i class="fab fa-facebook"></i>
                  </a>
                </li>
                <li style={{ marginLeft: "10px" }}>
                  <a
                    href="https://twitter.com/onlinehardwares?lang=en"
                    target="_blank"
                  >
                    <i class="fab fa-twitter"></i>
                  </a>
                </li>
                <li style={{ marginLeft: "10px" }}>
                  <a
                    href="https://www.instagram.com/kalanjiamhardware/"
                    target="_blank"
                  >
                    <i class="fab fa-instagram"></i>
                  </a>
                </li>
              </div>
            </div>
            <div class="col-md-12 col-lg-4">
              <div class="soc_link">
                <h3 className="text-white">Quick Links</h3>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="#about">About Us</a>
                </li>
                <li>
                  <a href="#service">Service</a>
                </li>
                <li>
                  <a href="#footer">Contact Us</a>
                </li>
              </div>
            </div>
            <div class="col-md-12 col-lg-4">
              <div class="map">
                <iframe
                  width="100%"
                  height="250px"
                  style={{ border: "0" }}
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>

          <div class="row p-0 pt-3 border-top border-white m-0 mt-2" id="lower">
            <div class="col-lg-6 col-md-12 p-0 footerfontposition">
              <div class="first_txt">
                {/* <span className="footerproduct footerfontsize">Powered by</span>
                <a
                  className="gtrendz-text footercopyright"
                  href="https://bechofy.in"
                  target="_blank"
                >
                  <span className="footerproductonhover footerfontsize">
                    {" "}
                    Bechofy
                  </span>
                  <span className="footerproduct footerfontsize"> - </span>
                </a> */}

                <span className="footerproduct footerfontsize">
                Design 
                  <a
                    className="gtrendz-text footercopyright"
                    href="http://globaltrendz.com/"
                    target="_blank"
                  >
                    <span className="footerproductonhover footerfontsize">
                      {" "}
                      Global Trendz
                    </span>
                  </a>
                </span>
              </div>
            </div>
            <div class="col-lg-6 p-0 footerfontposition col-md-12 text-lg-right">
              <div class="last_txt">
                <p className="footerproduct footerfontsize">
                  Copyright© {moment().format("YYYY")} Kalanjiam Hardware
                  Store. All Rights Reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Homepage;
